module.exports = __webpack_public_path__ + "static/media/secure.dd0e2ac9.png";